import { VideoSliderItem } from 'shared/components'

import img from 'assets/images/zaglushka.png'

export const SLIDER_ITEMS: VideoSliderItem[] = [
  {
    title: 'Создание',
    descr:
      'Разрабатываем идеи для создания оригинального контента. Привлекаем к сотрудничеству авторов сценария и продюсеров.',
    link: '/about',
    video: 'https://www.youtube.com/embed/avxldlRX7jw',
    bgImg: img,
    // btnText: 'Отправить заявку',
  },
]
